import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../../../constants/envVars';
import { useSetNotification } from '../../../../../context/Notification';
import useRequest from '../../../../../hooks/useRequest';
import { ApiEnvelope, ApiEnvelopeError } from '../../../types';
import { PortalLink } from '../types';
import { PORTAL_LINK_KEY } from './constants';

/** Generating a link deactivates every previously active link for the patient. */
const useGeneratePortalLink = (member_id: number | null | undefined) => {
    const req = useRequest();
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return useMutation<PortalLink, ApiEnvelopeError, void>({
        mutationFn: () =>
            req<ApiEnvelope<PortalLink>>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/portal-link/`,
                method: 'POST'
            }).then((response) => response.data),
        onSuccess: () => {
            setNotification({ message: 'New patient portal link generated', icon: 'checkmark' });
            queryClient.invalidateQueries({ queryKey: [PORTAL_LINK_KEY, member_id] });
        },
        onError: (error) => error
    });
};

export default useGeneratePortalLink;
